export const DefaultPageSizeOptions = [10, 25, 75];
